import dayjs from 'dayjs';

/**
 * Dates on this screen are read to answer "is this key still in use?", so they
 * are absolute rather than relative — "12 Mar 2026" settles it, "3 months ago"
 * starts an argument about which quarter.
 */
export function formatDate(value: string | null | undefined): string | null {
  if (!value) {
    return null;
  }

  const date = dayjs(value);

  return date.isValid() ? date.format('D MMM YYYY') : null;
}

export function formatDateTime(value: string | null | undefined): string | null {
  if (!value) {
    return null;
  }

  const date = dayjs(value);

  return date.isValid() ? date.format('D MMM YYYY, HH:mm') : null;
}
